<template>
  <div>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <td colspan="8">
              <h3 class="red--text">Produtos:</h3>
            </td>
          </tr>
        </thead>
        <thead>
          <tr>
            <th class="text-left">Código</th>
            <th class="text-left">Descrição</th>
            <th class="text-left">Estoque</th>
            <th class="text-left">P. Unit.</th>
            <th class="text-left">Quantidade</th>
            <th class="text-left">Subtotal</th>
            <th class="text-left">Desconto</th>
            <th class="text-left">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="p in getItensOrcamento" :key="p.id">
            <td>{{ p.produto_id }}</td>
            <td>{{ p.descricao }}</td>
            <td>{{ p.estoque }}</td>
            <td>{{ $helper.formatReal(parseFloat(p.preco)) }}</td>
            <td>{{ $helper.formatReal(parseFloat(p.quantidade)) }}</td>
            <td>{{ $helper.formatReal(parseFloat(p.subtotal)) }}</td>
            <td>{{ $helper.formatReal(parseFloat(p.desconto)) }}</td>
            <td>{{ $helper.formatReal(parseFloat(p.total)) }}</td>
            <!-- <td>
              <v-btn
                x-small
                color="error"
                @click="removerItemOrcamento(p)"
                outlined
              >
                <v-icon>delete_forever</v-icon>
              </v-btn>
              <v-btn
                x-small
                color="primary"
                class="ml-2"
                @click="visualizarProduto(p.produto_id)"
                v-if="$helper.verificaPermissao('visualizar-produto')"
                outlined
              >
                <v-icon>edit</v-icon>
              </v-btn>
            </td> -->
          </tr>
          <tr>
            <td class="text-md-right text-xs-right" colspan="7">
              <strong>Subtotal</strong>
            </td>
            <td>
              <strong>{{ getOrcamento.subtotal }}</strong>
            </td>
          </tr>
          <tr>
            <td class="text-md-right text-xs-right" colspan="7">
              <strong>Desconto</strong>
            </td>
            <td>
              <strong>{{ getOrcamento.desconto }}</strong>
            </td>
          </tr>
          <tr>
            <td class="text-md-right text-xs-right" colspan="7">
              <strong>Total</strong>
            </td>
            <td>
              <strong>{{ getOrcamento.total }}</strong>
            </td>
          </tr>
        </tbody>
      </template></v-simple-table
    >
    <br>
    <v-simple-table dense v-if="getOrcamento.cliente">
      <template v-slot:default>
        <thead>
          <tr>
            <th colspan="2">
              <h3 class="red--text">Cliente:</h3>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="getOrcamento.cliente">
            <td width="5%"><strong>Nome:</strong></td>
            <td>
              {{ getOrcamento.cliente.nome }}
              <TooltipButton
                @click.native="visualizarContato(getOrcamento.cliente.id)"
                classButton="ml-2"
                subtitle="Visualizar"
                icon="search"
                color="primary"
                v-if="
                  $helper.verificaPermissao('visualizar-contato') &&
                  getOrcamento.cliente
                "
              />
            </td>
          </tr>
          <tr>
            <td width="5%"><strong>Telefones:</strong></td>
            <td>
              {{
                getOrcamento.cliente.telefone
                  ? getOrcamento.cliente.telefone
                  : ""
              }}
              {{
                ` / ${
                  getOrcamento.cliente.celular1
                    ? getOrcamento.cliente.celular1
                    : ""
                }`
              }}
              {{
                ` / ${
                  getOrcamento.cliente.celular2
                    ? getOrcamento.cliente.celular2
                    : ""
                }`
              }}
            </td>
          </tr>
          <tr>
            <td width="5%"><strong>WhatsApp:</strong></td>
            <td>
              {{
                getOrcamento.cliente.whatsapp
                  ? getOrcamento.cliente.whatsapp
                  : ""
              }}
            </td>
          </tr>
        </tbody></template
      ></v-simple-table
    >
    <br>
    <v-simple-table dense>
      <template v-slot:default>
        <thead>
          <tr>
            <th colspan="2">
              <h3 class="red--text">Formas de Pagamento:</h3>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="f in getOrcamento.formas_pagamentos" :key="f.id">
            <td width="20%">{{ f.descricao }}</td>
            <td>{{ f.valor }}</td>
          </tr>
        </tbody></template
      ></v-simple-table
    >
    <ModalCadastroContato />
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import ModalCadastroContato from "@/pages/contato/ModalCadastro";

export default {
  components: {
    ModalCadastroContato,
  },
  computed: {
    ...mapGetters(["getOrcamento", "getOrcamento", "getItensOrcamento"]),
  },
  methods: {
    ...mapActions(["visualizarContato"]),
  },
};
</script>
